(function () {
    "use strict";

    angular
        .module("app")
        .component("checkout", { // checkout
            templateUrl: "src/app/checkout/checkout.html",
            controller: controller
        });

    function controller($q, $window, $location, $routeParams, session, toast, $rootScope, CART_TYPE_CODE) {
        const $ctrl = this;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        $ctrl.session = session;
        $ctrl.cart = session.cart;
        $ctrl.CART_TYPE_CODE = CART_TYPE_CODE;
        $ctrl.busy = true;
        $ctrl.billingAddress = null;
        $ctrl.shippingAddress = null;
        $ctrl.noCheckoutReasons = [];
        $ctrl.errors = [];
        $ctrl.noCalculateShippingReasons = [];
        $ctrl.noCalculateShippingErrors = [];
        $ctrl.noCalculateShippingCount = 0;
        $ctrl.customer_order_no = "";
        $ctrl.order_name = "";
        $ctrl.shipping_instructions = "";
        $ctrl.order_form_number = "";
        $ctrl.order_form_number_222 = "";
        $ctrl.order_form_number_222_confirm = "";
        $ctrl.order_form_number_prefix = (new Date().getFullYear().toString().substr(-2)) + "X";
        $ctrl.certificate = null;
        $ctrl.certificatePassword = null;
        $ctrl.CsosCheckoutMode = "CSOS";
        $ctrl.calculatingShipping = false;
        $ctrl.validatingOrderFormNumber = false;
        $ctrl.orderFormNumberIsUnique = true;
        $ctrl.notCsosDeaNumbers = [];
        $ctrl.notCsosDeaNumber = "";
        $ctrl.recurWeeklyDefaultStartDate = addDays(today, 7);
        $ctrl.recurBiweeklyDefaultStartDate = addDays(today, 14);
        $ctrl.recurMonthlyDefaultStartDate = addMonths(today, 1);
        $ctrl.recur = false;
        $ctrl.recurPeriod = "weekly";
        $ctrl.recurStartdate = $ctrl.recurWeeklyDefaultStartDate;

        $ctrl.certificates = () => session.certificates.certificates.filter(c => $ctrl.shippingAddress && $ctrl.shippingAddress.deas.some(dea => dea.identification_code === c.contact_dea));

        function addDays(date, days) {
            const result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        }

        function addMonths(date, months) {
            const result = new Date(date);
            result.setMonth(result.getMonth() + months);
            return result;
        }

        function getDeasWithAllCartItemSchedules() {
            return $ctrl.shippingAddress.deas.filter(sDea => session.cart.items.every(item => {

                return sDea.schedules.indexOf(item.schedule_name) >= 0;
            })).map(sDea => sDea.identification_code);
        };

        $ctrl.canCheckout = () => {
            $ctrl.noCheckoutReasons = [];

            if (session.cart.items.some(item => item.isUpdating))
                $ctrl.noCheckoutReasons.push("Finish Updating Item Qty");

            if (!$ctrl.shippingAddress) {
                $ctrl.noCheckoutReasons.push("Select Shipping Address");

                if (!$ctrl.billingAddress)
                    $ctrl.noCheckoutReasons.push("Select Billing Address");
            } else {

                if (!$ctrl.billingAddress)
                    $ctrl.noCheckoutReasons.push("Select Billing Address");

                if (session.cartTypeCode === CART_TYPE_CODE.CSOS) {

                    if ($ctrl.CsosCheckoutMode === "CSOS") {
                        if (!$ctrl.certificate)
                            $ctrl.noCheckoutReasons.push("Select CSOS Certificate");
                        else {
                            if (!$ctrl.certificatePassword)
                                $ctrl.noCheckoutReasons.push("Enter Certificate Password");
                            else if ($ctrl.order_form_number.length) {
                                if ($ctrl.order_form_number.length !== 6)
                                    $ctrl.noCheckoutReasons.push("Order Form Number must be 6 characters.");
                                else if ($ctrl.validatingOrderFormNumber)
                                    $ctrl.noCheckoutReasons.push("Validating Order Form Number...");
                                else if (!$ctrl.orderFormNumberIsUnique)
                                    $ctrl.noCheckoutReasons.push("Order Form Number must be unique.");
                            }
                        }
                    } else if ($ctrl.CsosCheckoutMode === "Form222") {
                        // form 222
                        if ($ctrl.order_form_number_222.length === 0) {
                            $ctrl.noCheckoutReasons.push("Enter Order Form Number");
                        } else if ($ctrl.order_form_number_222.length !== 9) {
                            $ctrl.noCheckoutReasons.push("Order Form Number must be 9 characters.");
                        } else {
                            if ($ctrl.order_form_number_222_confirm.length === 0) {
                                $ctrl.noCheckoutReasons.push("Enter Confirm Order Form Number");
                            } else {
                                if ($ctrl.order_form_number_222 !== $ctrl.order_form_number_222_confirm)
                                    $ctrl.noCheckoutReasons.push("Order Form Numbers do not match");
                            }
                        }
                    }

                }
            }

            if ($ctrl.cart.shippingMethod != null &&
                $ctrl.cart.shippingMethod.offer_saturday_delivery === "Y" &&
                $ctrl.cart.shippingMethod.useSaturdayShipping) {
                var deliveryPhoneInput = $ctrl.formShippingMethod.deliveryContactPhoneInput;

                if (deliveryPhoneInput.$invalid && deliveryPhoneInput.$error.required) {
                    $ctrl.noCheckoutReasons.push("Enter Delivery Contact Phone");
                } else if (deliveryPhoneInput.$invalid && deliveryPhoneInput.$error.pattern) {
                    $ctrl.noCheckoutReasons.push("Enter a valid Delivery Contact Phone");
                }
            }

            if (session.cart.shippingMethod == null || session.cart.shippingMethod.shipping_cost == null)
                $ctrl.noCheckoutReasons.push("Calculate Shipping");

            if ($ctrl.recur && $ctrl.recurStartdateHasError())
                $ctrl.noCheckoutReasons.push("Start Date is not valid.");

            return !$ctrl.noCheckoutReasons.length;
        };

        $ctrl.canCalculateShipping = () => {
            $ctrl.noCalculateShippingReasons = [];

            if (!$ctrl.shippingAddress)
                $ctrl.noCalculateShippingReasons.push("Select Shipping Address");

            if ($ctrl.cart.shippingMethod.is_overnight === "Y" && $ctrl.cart.shippingMethod.is_overnight_possible === "N")
                $ctrl.noCalculateShippingReasons.push($ctrl.cart.shippingMethod.why_overnight_not_possible);

            return !$ctrl.noCalculateShippingReasons.length;
        };

        $ctrl.$onInit = () => {
            if ($routeParams && $routeParams.orderId) {
                session.cart.getPurchaseOrder($routeParams.orderId).then(order => {
                    $ctrl.billingAddress =
                        $ctrl.session.addresses.billingAddresses.find(a => a.contact_id ===
                            order.bill_contact_id); // || undefined
                    $ctrl.shippingAddress =
                        $ctrl.session.addresses.shippingAddresses.find(a => a.contact_id ===
                            order.ship_contact_id); // || undefined
                    $ctrl.shipping_instructions = order.shipping_instructions;

                    $ctrl.changeAddress("shipping", $ctrl.shippingAddress);
                })
                    .catch(toast.errorHandler)
                    .finally(() => $ctrl.busy = false);
            } else {
                $ctrl.busy = false;
            }

            if ($ctrl.session.cartTypeCode === $ctrl.CART_TYPE_CODE.CSOS && !$ctrl.session.cart.containsScheduleII && $ctrl.session.cart.items.length > 0) {
                $ctrl.CsosCheckoutMode = "NotCSOS";
            }
        };

        $ctrl.changeAddress = (addressType, address) => {
            if (addressType === "shipping") {

                $ctrl.calculatingShipping = true;

                $ctrl.shippingAddress = address;
                if (session.cartTypeCode === CART_TYPE_CODE.CSOS) {
                    if ($ctrl.certificates().length) {
                        $ctrl.certificate = $ctrl.certificates()[0];
                        $ctrl.CsosCheckoutMode = "CSOS";
                    } else {
                        if ($ctrl.session.cart.containsScheduleII)
                            $ctrl.CsosCheckoutMode = "Form222";
                        else
                            $ctrl.CsosCheckoutMode = "NotCSOS";
                    }

                }

                session.cart
                    .loadShippingMethods(address.zip_code, address.contact_id)
                    .finally(() => $ctrl.calculatingShipping = false);;
                $ctrl.validateOrderFormNumber();

                const deas = getDeasWithAllCartItemSchedules();
                $ctrl.notCsosDeaNumbers = deas;
                $ctrl.notCsosDeaNumbers.unshift("Not Listed");
                if (deas.length <= 1)
                    $ctrl.notCsosDeaNumber = $ctrl.notCsosDeaNumbers[0];
                else
                    $ctrl.notCsosDeaNumber = $ctrl.notCsosDeaNumbers[1];

                // init delivery phone number
                $ctrl.delivery_contact_phone = address.phone;


            } else {
                $ctrl.billingAddress = address;
            }
        };

        $ctrl.showBundleSuggest = () => {
            //return !$ctrl.session.cart.items.some(i => i.incentives.filter(i => i.incentive_type_Code === "BND").length > 0);
            return false;
        };

        $ctrl.showAddCertificate = () => {
            if (!$ctrl.shippingAddress)
                return false;

            if (session.cartTypeCode !== CART_TYPE_CODE.CSOS)
                return false;

            const certs = session.certificates.certificates;

            if ($ctrl.certificates && certs.some(c => $ctrl.shippingAddress.deas.some(dea => dea.identification_code === c.contact_dea)))
                return false;
            return true;
        };


        $ctrl.showShippingCouldBeFreeMessage = () => {
            return true;
        };

        $ctrl.toggleSaturdayShipping = () => {
            session.cart.shippingMethod.shipping_cost = null;
        };

        $ctrl.calculateShipping = () => {
            $ctrl.calculatingShipping = true;
            $ctrl.noCalculateShippingErrors = [];
            const shippingContactId = $ctrl.shippingAddress.contact_id;
            const saturdayShipping = !!session.cart.shippingMethod.useSaturdayShipping;
            return session.cart
                .calculateShipping(shippingContactId, saturdayShipping)
                .then(result => {
                    if (!result.success) {
                        console.error(result.reason);
                        calcShippingFailed();
                    }
                    else
                        $ctrl.noCalculateShippingCount = 0;
                })
                .catch(result => {
                    calcShippingFailed();
                })
                .finally(() => $ctrl.calculatingShipping = false);
        };

        function calcShippingFailed() {
            $ctrl.noCalculateShippingCount++;
            $ctrl.noCalculateShippingErrors.push("Calculate Shipping Failed. Please try again.");
            if ($ctrl.noCalculateShippingCount >= 2)
                $ctrl.noCalculateShippingErrors.push("If this keeps happening please contact support.");
        }

        $ctrl.validateOrderFormNumber = () => {
            $ctrl.validatingOrderFormNumber = true;
            const buyerDeaNumber = $ctrl.certificate ? $ctrl.certificate.contact_dea : null;

            let orderFormNumber = null;
            if ($ctrl.CsosCheckoutMode === "CSOS")
                orderFormNumber = $ctrl.order_form_number.length > 0 ? $ctrl.order_form_number_prefix + $ctrl.order_form_number : null;
            else
                orderFormNumber = $ctrl.order_form_number.length > 0 ? $ctrl.order_form_number : null;


            if (!buyerDeaNumber || !orderFormNumber) {
                $ctrl.validatingOrderFormNumber = false;
                return;
            }


            session.cart
                .isOrderFormNumberUnique(buyerDeaNumber, orderFormNumber)
                .then(result => {
                    if (result.does_exist)
                        $ctrl.orderFormNumberIsUnique = false;
                    else
                        $ctrl.orderFormNumberIsUnique = true;
                })
                .finally(() => $ctrl.validatingOrderFormNumber = false);
        };

        $ctrl.checkoutClicked = () => {
            $ctrl.errors = [];
            $ctrl.busy = true;

            if (session.cartTypeCode === CART_TYPE_CODE.CSOS && $ctrl.CsosCheckoutMode === "CSOS") {
                session
                    .cart
                    .createPurchaseOrderCsos(
                        $ctrl.billingAddress.contact_id,
                        $ctrl.shippingAddress.contact_id,
                        $ctrl.customer_order_no,
                        $ctrl.order_name,
                        $ctrl.shipping_instructions,
                        $ctrl.certificate.contact_dea,
                        $ctrl.certificate.certificate_id,
                        $ctrl.certificatePassword,
                        $ctrl.order_form_number.length ? $ctrl.order_form_number_prefix + $ctrl.order_form_number : null,
                        $ctrl.delivery_contact_phone
                    )
                    .then(response => {
                        if (response.Success) {
                            //$window.ga("send", "event", "Orders", "orderCreated");
                            toast.success("Checkout", "Success");
                            $location.path(`/order-complete/${response.OrderId}`);
                        } else {
                            console.log("Checkout Failed", response);
                            if (response.InvalidPassword) { $ctrl.errors.push("Invalid Certificate Password"); return; }

                            if (response.SaveOrderResult) {
                                const sor = response.SaveOrderResult;

                                if (sor.ValidateOrderResult) {
                                    const vor = sor.ValidateOrderResult;

                                    if (!!vor.DrugSchedulesInvalid) {
                                        $ctrl.errors.push(`${vor.InvalidSchedules} cannot be purchased with this certificate.`);
                                        console.log(`Cert Schedules:${vor.CertSchedules}`);
                                        return;
                                    }

                                    if (vor.ValidateCertificateResult) {
                                        const vcr = vor.ValidateCertificateResult;

                                        if (!!vcr.LdapNotAvailable) $ctrl.errors.push("Failed to contact the DEA LDAP server. Please try again later.");
                                        if (!!vcr.DeaNumberNotValid) { $ctrl.errors.push("DEA Number is not correct."); return; }
                                        if (!!vcr.Expired) { $ctrl.errors.push("The certificate is Expired."); return; }
                                        if (!!vcr.PrivateKeyMissing) { $ctrl.errors.push("The certificate is missing the private key."); return; }
                                        if (!!vcr.Revoked) { $ctrl.errors.push("The certificate has been revoked."); return; }
                                        if (!!vcr.ChainNotValid) { $ctrl.errors.push("The certificate is not a valid certificate for CSOS (Certificate chain not valid)."); return; }
                                    }
                                }
                            }
                            if (!$ctrl.errors.length)
                                $ctrl.errors.push("Please refresh the page and try again.");
                        }
                    })
                    .catch(toast.errorHandler)
                    .finally(() => $ctrl.busy = false);
            } else {

                let cs_dea_number = null;
                if (session.cartTypeCode === CART_TYPE_CODE.CSOS && $ctrl.CsosCheckoutMode === "NotCSOS") {
                    if ($ctrl.notCsosDeaNumber !== "Not Listed")
                        cs_dea_number = $ctrl.notCsosDeaNumber;
                }

                session
                    .cart
                    .createPurchaseOrder(
                        $ctrl.billingAddress.contact_id,
                        $ctrl.shippingAddress.contact_id,
                        $ctrl.customer_order_no,
                        $ctrl.order_name,
                        $ctrl.shipping_instructions,
                        $ctrl.order_form_number_222,
                        cs_dea_number,
                        $ctrl.recur,
                        $ctrl.recur ? $ctrl.recurPeriod : null,
                        $ctrl.delivery_contact_phone,
                        $ctrl.recurStartdate
                    )
                    .then(orderId => {
                        //$window.ga("send", "event", "Orders", "orderCreated");
                        toast.success("Checkout", "Success");
                        $location.path(`/order-complete/${orderId}`);
                    })
                    .catch(toast.errorHandler)
                    .finally(() => $ctrl.busy = false);
            }
        };

        $ctrl.recurPeriodChanged = () => {
            const period = $ctrl.recurPeriod;
            switch (period) {
                case "weekly":
                    $ctrl.recurStartdate = $ctrl.recurWeeklyDefaultStartDate;
                    break;
                case "biweekly":
                    $ctrl.recurStartdate = $ctrl.recurBiweeklyDefaultStartDate;
                    break;
                case "monthly":
                    $ctrl.recurStartdate = $ctrl.recurMonthlyDefaultStartDate;
                    break;
            }
        };

        $ctrl.recurStartdateHasError = () => {
            const minDate = addDays(today, 1);
            const startDate = $ctrl.recurStartdate;

            if (!startDate)
                return true;

            if (startDate < minDate)
                return true;

            return false;
        };

        //DATEPICKER FUNCTION
        $ctrl.toggles = {};
        $ctrl.toggleDatePicker = datePicker => {
            $ctrl.toggles[datePicker] = !$ctrl.toggles[datePicker];
        };

        $ctrl.datePickerOptions = {
            "show-weeks": false,
            timezone: "utc",
            minDate: addDays(today, 1)
        };
    }
    controller.$inject = ["$q", "$window", "$location", "$routeParams", "sessionService", "stToastFactory", "$rootScope", "CART_TYPE_CODE"];

})()